import { FC } from 'react';

import Map from '@components/ui/map/Map';
import { MapPin2Line } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  Wrapper,
  Label,
  SummaryWrapper,
  SummaryText,
  LocationName,
  LocationAddress,
  MapWrapper,
  IconWrapper,
} from './styled';

export interface HotelLocationProps {
  locationName?: string;
  locationAddress?: string;
  latitude: number;
  longitude: number;
}

const HotelLocation: FC<HotelLocationProps> = ({
  locationName,
  locationAddress,
  latitude,
  longitude,
}) => {
  return (
    <Wrapper>
      <Label>Otel Konumu</Label>

      <SummaryWrapper>
        <IconWrapper>
          <CustomIcon
            icon={MapPin2Line}
            fontSize={24}
            paletteColor='grey1100'
          />
        </IconWrapper>

        <SummaryText>
          <LocationName>{locationName}</LocationName>
          <LocationAddress>{locationAddress}</LocationAddress>
        </SummaryText>
      </SummaryWrapper>

      <MapWrapper fullScreen={false}>
        {locationName ? (
          <Map latitude={latitude} longitude={longitude} />
        ) : null}
      </MapWrapper>
    </Wrapper>
  );
};

export default HotelLocation;
